import React from "react";
import { FaWhatsapp, FaInstagram } from "react-icons/fa"; // Import icons from react-icons
import { Link } from "react-router-dom";

const Footer = () => {
  const footerStyle = {
    backgroundColor: "#000", // Black background
    color: "#fff", // White text color
    padding: "2rem 1rem",
    textAlign: "center",
    position: "relative",
    bottom: 0,
    width: "100%",
  };

  const menuStyle = {
    display: "flex",
    justifyContent: "center",
    gap: "2rem",
    marginBottom: "1rem",
  };

  const contactStyle = {
    fontSize: "1rem",
    margin: "1rem 0",
  };

  const iconStyle = {
    margin: "0 1rem",
    fontSize: "1.5rem",
    cursor: "pointer",
    color: "#d4a256", // Change this to your preferred icon color
  };

  const copyrightStyle = {
    fontSize: "0.8rem",
    marginTop: "1rem",
  };

  return (
    <footer style={footerStyle}>
      {/* First Row: Navigation Menu */}
      <div style={menuStyle}>
        <Link to="/" style={{ color: "#fff", textDecoration: "none" }}>Home</Link>
        <Link to="/videos" style={{ color: "#fff", textDecoration: "none" }}>Videos</Link>
        <Link to="/track" style={{ color: "#fff", textDecoration: "none" }}>Track</Link>
        {/* <Link to="/contact" style={{ color: "#fff", textDecoration: "none" }}>Contact Us</Link> */}
      </div>

      {/* Second Row: Logo, Contact Information, and Copyright */}
      <div>
        <img src="/logo.png" alt="Company Logo" style={{ width: "300px", marginBottom: "1rem" }} />
        <h2>e Digital Creative Studio</h2> {/* Replace with your actual company name */}

        <div style={contactStyle}>
          <p>Contact Us: +91-6393342414, +91-9455588428</p>
          <p>edigitalstudio1@gmail.com</p>
          <div>
            <a
              href="https://wa.me/919455588428" // Replace with your WhatsApp link
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp style={iconStyle} />
            </a>
            <a
              href="https://www.instagram.com/edigitalinvitation/" // Replace with your Instagram link
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram style={iconStyle} />
            </a>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div style={copyrightStyle}>
        <p>&copy; {new Date().getFullYear()} e Digital Creative Studio. All rights reserved.</p>
        <Link to="/login" style={{ color: "#fff", textDecoration: "none" }}>&copy; Admin Login</Link>
      </div>
    </footer>
  );
};

export default Footer;
